export const calendar = {
  title: 'Minha Agenda',
  subtitle: 'Gerencie sua disponibilidade e sincronize seus calendários',
  calendar: {
    today: 'Hoje',
    month: 'Mês',
    week: 'Semana',
    day: 'Dia',
    selectDates: 'Selecionar datas',
    blockDates: 'Bloquear datas',
    unblockDates: 'Desbloquear estas datas',
    addNote: 'Adicionar nota',
    selectEvent: 'Selecionar um evento',
    nMonths: 'meses',
    oneMonth: '1 mês',
    months: { january: 'Janeiro', february: 'Fevereiro', march: 'Março', april: 'Abril', may: 'Maio', june: 'Junho', july: 'Julho', august: 'Agosto', september: 'Setembro', october: 'Outubro', november: 'Novembro', december: 'Dezembro' },
    days: { monday: 'Seg', tuesday: 'Ter', wednesday: 'Qua', thursday: 'Qui', friday: 'Sex', saturday: 'Sáb', sunday: 'Dom' }
  },
  sync: { title: 'Sincronização iCal', description: 'Conecte seu calendário Airbnb ou PMS para sincronizar automaticamente sua disponibilidade', addConnection: 'Adicionar conexão', noConnections: 'Sem conexões', icalUrl: 'URL iCal', icalUrlPlaceholder: 'https://www.airbnb.com/calendar/ical/...', platform: 'Plataforma', platformPlaceholder: 'Ex: Airbnb, Booking.com, PMS...', syncNow: 'Sincronizar agora', lastSync: 'Última sincronização', eventsImported: 'eventos importados', status: { synced: 'Sincronizado', pending: 'Pendente', error: 'Erro', syncing: 'Sincronizando...' }, remove: 'Remover', edit: 'Editar' },
  exchanges: { title: 'Trocas Futuras', noExchanges: 'Nenhuma troca planejada', viewProfile: 'Ver perfil', sendMessage: 'Enviar mensagem', confirm: 'Confirmar', decline: 'Recusar', cancel: 'Cancelar', guests: 'viajantes', status: { confirmed: 'Confirmado', pending: 'Pendente', proposal: 'Proposta', blocked: 'Bloqueado' } },
  legend: { title: 'Legenda', available: 'Disponível', confirmed: 'Troca confirmada', pending: 'Solicitação pendente', proposal: 'Proposta', blocked: 'Datas bloqueadas' },
  blockModal: { title: 'Bloquear datas', reason: 'Motivo (opcional)', reasonPlaceholder: 'Ex: Reformas, férias pessoais...', from: 'De', to: 'Até', block: 'Bloquear', cancel: 'Cancelar' },
  notifications: { datesBlocked: 'Datas bloqueadas com sucesso', datesUnblocked: 'Datas desbloqueadas com sucesso', syncSuccess: 'Sincronização bem-sucedida', syncError: 'Erro de sincronização', connectionAdded: 'Conexão adicionada com sucesso', connectionRemoved: 'Conexão removida', exchangeConfirmed: 'Troca confirmada', exchangeDeclined: 'Troca recusada' },
  details: 'Detalhes',
  upcomingExchanges: 'Trocas Futuras',
  noExchangesPlanned: 'Nenhuma troca planejada',
  daysSelected: 'dias selecionados',
  daySelected: 'dia selecionado',
  from: 'De',
  to: 'Até',
  reasonOptional: 'Motivo (opcional)',
  reasonPlaceholder: 'Ex: Reformas, férias pessoais...',
  block: 'Bloquear',
  cancel: 'Cancelar',
  namePlaceholder: 'Nome (ex: Airbnb)',
  filters: 'Filtros',
  actions: 'Ações',
  connections: 'Conexões'
};

export default calendar;
